/******/ (() => { // webpackBootstrap
/******/ 	"use strict";

;// ./src/js/Footer.js
class Footer {
  constructor() {
    this.titlesSelector = '.footer__block-title';
    this.blockSelector = '.footer__block';
    this.descSelector = '.footer__block-description';
    this.descModifier = 'footer__block-description--reveal';
  }

  init = () => {
    const titles = document.querySelectorAll(this.titlesSelector);
    if (!titles) return;

    titles.forEach((title) => {
      title.addEventListener('click', () => {
        const container = title.closest(this.blockSelector);
        const description = container.querySelector(this.descSelector);

        if (description.classList.contains(this.descModifier)) {
          description.classList.remove(this.descModifier);
        } else {
          description.classList.add(this.descModifier);
        }
      });
    });
  };
}

;// ./src/js/Cart.js
class Cart {
  constructor() {
    this.quantityContainerSelector = '.line-item__quantity-container';
    this.lessSelector = '.line-item__less';
    this.moreSelector = '.line-item__more';
    this.inputSelector = 'input';
  }

  init = () => {
    this.handleQuantityContainer();
    this.setupEventListeners();
  };

  setupEventListeners = () => {
    window.addEventListener('cart:change', (event) => {
      const delay = event.detail.baseEvent === 'variant:add' ? 0 : 1250;
      setTimeout(() => {
        this.handleQuantityContainer();
      }, delay);
    });

    window.addEventListener('cart:refresh', () => {
      console.log('Cart refreshed');
      setTimeout(() => {
        this.handleQuantityContainer();
      }, 500);
    });

    document.addEventListener('line-item:change', (event) => {
      console.log('Line item changed:', event);
      setTimeout(() => {
        this.handleQuantityContainer();
      }, 100);
    });
  };

  handleQuantityContainer = () => {
    const quantityContainers = document.querySelectorAll(
      this.quantityContainerSelector
    );
    if (!quantityContainers.length > 0) return;

    quantityContainers.forEach((quantityContainer) => {
      const less = quantityContainer.querySelector(this.lessSelector);
      const more = quantityContainer.querySelector(this.moreSelector);

      if (!less && !more) return;

      less.removeEventListener('click', this.decrement);
      more.removeEventListener('click', this.increment);

      less.addEventListener('click', (e) => {
        this.decrement(e);
      });

      more.addEventListener('click', (e) => {
        this.increment(e);
      });
    });
  };

  decrement = (event) => { 
    const container = event.target.closest(this.quantityContainerSelector);
    const input = container.querySelector(this.inputSelector);

    input.value = parseInt(input.value) - 1;
    this.triggerChangeEvent(input);
  };

  increment = (event) => {
    const container = event.target.closest(this.quantityContainerSelector);
    const input = container.querySelector(this.inputSelector);

    const max = input.getAttribute('max');

    if (!max || parseInt(input.value, 10) < parseInt(max, 10)) {
      input.value = parseInt(input.value, 10) + 1;
      this.triggerChangeEvent(input);
    }
  };

  triggerChangeEvent = (input) => {
    let event = new Event('change', {
      bubbles: true,
      cancelable: true,
    });
    input.dispatchEvent(event);
  };
}

;// ./src/js/ObfLinks.js
class ObfLinks {
  init = () => {
    this.eventTypes = ['mouseover', 'focusin'];

    this.links = document.querySelectorAll('[data-href]');

    if (this.links.length > 0) {
      this.eventTypes.forEach((eventType) => {
        document.addEventListener(eventType, () =>
          this.mouseOverHandler(this.links)
        );
      });

      this.links.forEach((item) => {
        item.addEventListener('click', () => this.clickHandler(item));
      });
    }
  };

  mouseOverHandler = (links) => {
    links.forEach((item) => this.transformHref(item));
    this.eventTypes.forEach((eventType) => {
      document.removeEventListener(eventType, this.mouseOverHandler);
    });
  };

  transformHref = (element) => {
    if (element.dataset.href) {
      element.href = atob(element.dataset.href);
      delete element.dataset.href;
    }
  };

  clickHandler = (item) => {
    this.transformHref(item);
    item.removeEventListener('click', this.clickHandler);
  };
}

;// ./src/js/ProductQuickAddMobile.js
class ProductQuickAddMobile {
  constructor() {
    this.agJsWidgetSelector = '.agJsWidget';
    this.productSelector = '.product';
    this.mainButtonSelector = '.product-info__buy-buttons';
    this.quickAddButtonSelector = '.product-quick-add';
    this.quantitySelectorInputSelector = '.product-info .quantity-selector .quantity-selector__input'
    this.quantitySelectorQuickInputMobileSelector = '.product-quick-add__quantity-selector--mobile .quantity-selector__input';
    this.quantitySelectorQuickInputDesktopSelector = '.product-quick-add__quantity-selector--desktop .quantity-selector__input';
  }

  init = async () => {
    const productPage = document.querySelector(this.productSelector);
    if (!productPage) return;

    const mainButton = productPage.querySelector(this.mainButtonSelector);
    this.quickAddButton = document.querySelector(this.quickAddButtonSelector);
    this.quantitySelectorInput = productPage.querySelector(this.quantitySelectorInputSelector);
    this.quantitySelectorQuickInputMobile = document.querySelector(this.quantitySelectorQuickInputMobileSelector);
    this.quantitySelectorQuickInputDesktop = document.querySelector(this.quantitySelectorQuickInputDesktopSelector);

    if (!mainButton || !this.quickAddButton || !this.quantitySelectorInput || !this.quantitySelectorQuickInputMobile || !this.quantitySelectorQuickInputDesktop) return;

    this.synchronizeQuantityInputs();
    
    const agJsWidget = await this.waitForElement(this.agJsWidgetSelector);

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.quickAddButton.classList.remove('is-visible');
          agJsWidget.classList.remove('agJsWidget--hidden');
        } else {
          this.quickAddButton.classList.add('is-visible');
          agJsWidget.classList.add('agJsWidget--hidden');
        }
      });
    });

    observer.observe(mainButton);
  };

  waitForElement = (selector) => {
    return new Promise((resolve) => {
      const element = document.querySelector(selector);
      if (element) {
        resolve(element)
        return;
      }

      const observer = new MutationObserver(() => {
        const el = document.querySelector(selector);
        if (el) {
          observer.disconnect();
          resolve(el);
        }
      })

      observer.observe(document, {
        childList: true,
        subtree: true,
      });
    })
  }

  synchronizeQuantityInputs = () => {
    this.quantitySelectorInput.addEventListener('change', (event) => {
      this.quantitySelectorQuickInputMobile.value = event.target.value;
      this.quantitySelectorQuickInputDesktop.value = event.target.value;
    });
    this.quantitySelectorQuickInputMobile.addEventListener('change', (event) => {
      this.quantitySelectorInput.value = event.target.value;
      this.quantitySelectorQuickInputDesktop.value = event.target.value;
    });
    this.quantitySelectorQuickInputDesktop.addEventListener('change', (event) => {
      this.quantitySelectorInput.value = event.target.value;
      this.quantitySelectorQuickInputMobile.value = event.target.value;
    });
  };
}

;// ./src/js/Header.js
class Header {
  constructor() {
    this.headerSelector = 'header';
    this.disabledContentSelector = '.disabled-content';
    this.disabledContenShowModifier = 'disabled-content--show';
    this.searchConfigs = [
      {
        searchDrawerSelector: '.search-drawer--in-header',
        resultsSelector: '.search-drawer--in-header .predictive-search',
        wrapperSelector: '.search-drawer--in-header .search-drawer__search-input-wrapper',
        inputSelector: '.search-drawer--in-header .search-drawer__search-input'
      },
      {
        searchDrawerSelector: '.search-drawer--under-header',
        resultsSelector: '.search-drawer--under-header .predictive-search',
        wrapperSelector: '.search-drawer--under-header .search-drawer__search-input-wrapper',
        inputSelector: '.search-drawer--under-header .search-drawer__search-input'
      }
    ];
  }

  init = () => {
    const header = document.querySelector(this.headerSelector);
    const disabledContent = document.querySelector(this.disabledContentSelector);
    
    if (!header || !disabledContent) return;

    this.searchConfigs.forEach(config => this.initSearch(config, disabledContent));
  }

  initSearch = (config, disabledContent) => {
    const searchResults = document.querySelector(config.resultsSelector);
    const searchInputWrapper = document.querySelector(config.wrapperSelector);
    
    if (!searchResults || !searchInputWrapper) return;
    
    const searchInput = searchInputWrapper.querySelector(config.inputSelector);
    if (!searchInput) return;

    const rect = searchInputWrapper.getBoundingClientRect();
    searchResults.style.top = `${rect?.height}px`;
    
    this.handleCloseDisabledContent(disabledContent, searchInput);

    const searchDrawer = document.querySelector(config.searchDrawerSelector);
    if (!searchDrawer) return;
    
    searchInput.addEventListener('input', this.debounce((event) => {
      if (searchDrawer.classList.contains('search-drawer--hidden')) {
        searchDrawer.classList.remove('search-drawer--hidden');
      };

      if (event.target.value.length > 0) {
        disabledContent.classList.add(this.disabledContenShowModifier);
      } else {
        disabledContent.classList.remove(this.disabledContenShowModifier);
      }
    }, 300));
  }

  handleCloseDisabledContent = (disabledContent, searchInput) => {
    if (!disabledContent) return;
    
    const closeSearch = () => {
      disabledContent.classList.remove(this.disabledContenShowModifier);
      searchInput.value = '';
      searchInput.dispatchEvent(new Event('input', { bubbles: true }));
    };

    disabledContent.addEventListener('click', closeSearch);

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeSearch();
    });
  }

  debounce = (func, wait) => {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), wait);
    };
  }
}

;// ./src/main.js







// JS goes here
window.addEventListener('load', () => {
  const classes = [new Footer(), new Cart(), new ObfLinks(), new ProductQuickAddMobile(), new Header()];
  classes.forEach((classe) => classe.init());
});

/******/ })()
;